import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import DivisionChapter from "@/components/site/DivisionChapter";
import KineticBreaker from "@/components/site/KineticBreaker";
import SideRail from "@/components/site/SideRail";
import Footer from "@/components/site/Footer";
import Intro from "@/components/site/Intro";
import { DIVISIONS } from "@/data/divisions";
import { useLang } from "@/context/LanguageContext";

const BREAKER_WORDS = {
  print: { en: "PRINT", fr: "IMPRIME" },
  shirt: { en: "WEAR", fr: "PORTE" },
  sticker: { en: "STICK", fr: "COLLE" },
  deco: { en: "FRAME", fr: "ENCADRE" },
  pack: { en: "WRAP·IT", fr: "EMBALLE" },
  wrap: { en: "SKIN", fr: "HABILLE" },
  prod: { en: "ROLL", fr: "ACTION" },
};

const Home = () => {
  const { t, lang } = useLang();
  const divisionsRef = useRef(null);
  const [introDone, setIntroDone] = useState(false);

  const scrollToDivisions = () => {
    divisionsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main className="grain relative">
      <Intro onDone={() => setIntroDone(true)} />
      <Hero onScrollDown={scrollToDivisions} ready={introDone} />
      <Marquee />
      <Manifesto />

      {/* Divisions preamble */}
      <section
        ref={divisionsRef}
        className="relative px-6 md:px-10 py-24 md:py-32 border-t border-white/10 overflow-hidden"
      >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-end gap-8">
          <div>
            <div className="text-[0.7rem] tracking-hair uppercase text-white/60 mb-4">
              — {t.divisions.kicker}
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-display uppercase text-white text-6xl md:text-8xl lg:text-9xl leading-[0.9]"
            >
              {t.divisions.heading}
            </motion.h2>
          </div>
          <div className="text-white/40 text-[0.65rem] tracking-hair uppercase">
            01 → 07
          </div>
        </div>
      </section>

      <SideRail />

      {DIVISIONS.map((d, i) => (
        <React.Fragment key={d.slug}>
          <DivisionChapter division={d} total={DIVISIONS.length} invert={i % 2 === 1} />
          {i < DIVISIONS.length - 1 && (
            <KineticBreaker
              word={BREAKER_WORDS[DIVISIONS[i + 1].slug][lang]}
              accent={DIVISIONS[i + 1].accent}
              tilt={i % 2 === 0 ? -2 : 2}
            />
          )}
        </React.Fragment>
      ))}

      <Footer />
    </main>
  );
};

export default Home;
